import img1 from '../../assets/images/projects/doctors-portal.png';
import img11 from '../../assets/images/projects/doctors-portal.jpg';
import img2 from '../../assets/images/projects/Hekto.png';
import img22 from '../../assets/images/projects/Hekto.jpg';
import img3 from '../../assets/images/projects/red-onion.png';
import img33 from '../../assets/images/projects/red-onion.jpg';
import img4 from '../../assets/images/projects/travel-ride.png';
import img44 from '../../assets/images/projects/travel-ride.jpg';
import img5 from '../../assets/images/projects/rezilla.png';
import img55 from '../../assets/images/projects/rezilla.jpg';
import img6 from '../../assets/images/projects/honda-cbr.png';
import img66 from '../../assets/images/projects/honda-cbr.jpg';

export const projectsData = [
  {
    _id: 1,
    projectName: 'Rezilla',
    img: img5,
    demoImg: img55,
  },
  {
    _id: 2,
    projectName: 'Travel Ride',
    img: img4,
    demoImg: img44,
  },
  {
    _id: 3,
    projectName: 'Doctors Portal',
    img: img1,
    demoImg: img11,
  },
  {
    _id: 4,
    projectName: 'Hekto',
    img: img2,
    demoImg: img22,
  },
  {
    _id: 5,
    projectName: 'Red Onion',
    img: img3,
    demoImg: img33,
  },
  {
    _id: 6,
    projectName: 'Honda CBR',
    img: img6,
    demoImg: img66,
  },
];

export const BgPositionTop = (e) => {
  e.target.style.backgroundPosition = 'bottom';
};
export const BgPositionBottom = (e) => {
  e.target.style.backgroundPosition = 'top';
};
